// 売上系チャートで共通利用する整形・配色ヘルパー。
import { trendColorForIndex } from '../insightStageDefinitions';

export { trendColorForIndex };

/** 金額を ¥ 付きカンマ区切りに整形する */
export function formatYen(value: number): string {
  return `¥${Math.round(value).toLocaleString('ja-JP')}`;
}

/**
 * バケット文字列を表示用ラベルに整形する。
 * 月: "YYYY-MM" → "M月"（ただし1月＝年初は "YYYY年1月"）
 * 週: "YYYY-Wnn" → "nn週"
 * 日: "YYYY-MM-DD" → "M/D"
 */
export function formatPeriodLabel(period: string): string {
  const dayMatch = period.match(/^\d{4}-(\d{1,2})-(\d{1,2})$/);
  if (dayMatch) return `${parseInt(dayMatch[1], 10)}/${parseInt(dayMatch[2], 10)}`;

  const weekMatch = period.match(/^\d{4}-W(\d{1,2})$/);
  if (weekMatch) return `${parseInt(weekMatch[1], 10)}週`;

  const monthMatch = period.match(/^(\d{4})-(\d{1,2})$/);
  if (monthMatch) {
    const month = parseInt(monthMatch[2], 10);
    return month === 1 ? `${monthMatch[1]}年1月` : `${month}月`;
  }

  return period;
}

// Recharts の軸・グリッドの配色（InsightTrendChart と揃える）。
export const AXIS_TICK_COLOR = '#6D6D6D';
export const AXIS_LABEL_COLOR = '#888888';
export const GRID_COLOR = '#DFE1E1';

// クリック時に Recharts の SVG / バー・線などにフォーカスのアウトラインが出るのを
// 全要素（子孫含む）で確実に抑止する。
export const CHART_FOCUS_RESET =
  '[&_.recharts-wrapper:focus]:outline-hidden [&_.recharts-surface:focus]:outline-hidden [&_.recharts-wrapper_*:focus]:outline-hidden [&_.recharts-wrapper_*:focus-visible]:outline-hidden';
